import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { useTranslation } from 'react-i18next';
import ProductOverviewList from '../Components/ProductOverviewList';
import ProductVersionList from '../Components/ProductVersionList';
import productOverviewActions from '../Actions/productOverviewActions';
import Card, { CardContainer, CardRow, DefaultCard } from "../Components/Card/Card";

function ProductOverviewContainer({productList, productOverviewActions}) {
    const [searchString, setSearchString] = useState('');
    const {t} = useTranslation();

    useEffect(() => {
        if (!productList) {
            productOverviewActions.getProducts();
        }
    }, [])

    const filteredProductList = productList && productList.filter(({productName}) => {
        return productName.toLowerCase().indexOf(searchString.toLowerCase()) >= 0;
    });

    return (
        <CardContainer>
            <CardRow orientation={"horizontal"}>
                <DefaultCard title={t("productOverview.productOverviewText")}>
                    <Card.Content>
                        <div className='productoverviewsection col-xs-7'>
                            <div className='form-group search-group'>
                                <input type="text" className='form-control' aria-describedby='searchBlock'
                                       placeholder='Search by Product Name'
                                       onChange={(e) => setSearchString(e.target.value)}/>
                            </div>
                        </div>
                        <div className='productOverviewListContainer'>
                            <ProductOverviewList productList={filteredProductList}/>
                        </div>
                    </Card.Content>
                </DefaultCard>
                <DefaultCard title={t("productOverview.productversions")}>
                    <Card.Content>
                        <div className='productoverviewsection productVersionContainer-scroll'>
                            <ProductVersionList/>
                        </div>
                    </Card.Content>
                </DefaultCard>
            </CardRow>
        </CardContainer>
    )
}

function mapStateToProps(state) {
    return {
      productList: state.ProductOverviewReducer.productList,
    }
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      productOverviewActions: bindActionCreators(productOverviewActions, dispatch),
    }
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(ProductOverviewContainer);